import { CustomYup, isValidInternationalPhone } from '@/utils'

export const validationSchema = (roleName = '') => {
  return CustomYup.object({
    role_ids: CustomYup.array().min(1, 'Perfil es requerido'),
    resource_id: CustomYup.string()
      .nullable()
      .when([], {
        is: () => roleName === 'contractor',
        then: () => CustomYup.string().required('Contratista es requerido')
      }),
    account_managment_id: CustomYup.number()
      .nullable()
      .when([], {
        is: () => roleName === 'Administrador de contrato',
        then: () =>
          CustomYup.number().required('Gerencia y subgerencia son requeridos')
      }),
    account_office_id: CustomYup.number()
      .nullable()
      .when([], {
        is: () => roleName === 'Control de acceso',
        then: () => CustomYup.number().required('Dependencia es requerido')
      }),

    has_local_document_number: CustomYup.boolean(),
    phone: CustomYup.string()
      .nullable()
      .test(
        'international-phone-format',
        'Teléfono inválido. Usa formato internacional, por ejemplo: +56912345678',
        (value) => isValidInternationalPhone(value)
      ),
    document_number: CustomYup.string()
      .when('has_local_document_number', {
        is: false,
        then: () =>
          CustomYup.string()
            .matches(/^[0-9a-zA-Z]+$/, 'Número de documento inválido')
            .required('Número de documento es requerido'),
        otherwise: () => CustomYup.string().rut()
      })
  })
}
